import { PreferredCommunicationMethod } from "~/utils/constants";
import { TBooking } from "./booking";
import { TTemplate } from "./template";

export enum RecipientType {
  ASSIGNED_STAFF = 'assigned_staff',
  MENTIONED_USERS = 'mentioned_users',
  ALL_ADMINS = 'all_admins',
  ALL_STAFF = 'all_staff',
  BOOKING_CLIENT = 'booking_client',
  SERVICE_CLIENTS = 'service_clients',
  SPECIFIC_USERS = 'specific_users',
  SPECIFIC_STAFF = 'specific_staff',
  SPECIFIC_CLIENTS = 'specific_clients',
}

export type TCommunication = {
  id: string; // From BaseEntity
  createdAt: Date; // From BaseEntity
  updatedAt: Date; // From BaseEntity
  name: string;
  communicationRef: string;
  body: string | null;
  htmlBody?: string | null;
  subject: string | null;
  status: "delivered" | "failed" | "pending" | null;
  templateId: string | null;
  jobTicketId: string | null;
  channels: PreferredCommunicationMethod;
  template: TTemplate;
  jobTicket: TBooking;
  // Multi-recipient support
  recipientTypes?: RecipientType[];
  recipientIds?: string[];
  recipientEmails?: string[];
  sentToCount?: number;
  // Email reply tracking
  parentCommunicationId?: string | null;
  emailThreadId?: string | null;
  isReply?: boolean;
  replyToEmail?: string | null;
  replyFromEmail?: string | null;
  replyFromName?: string | null;
  messageId?: string | null;
  inReplyTo?: string | null;
  parentCommunication?: TCommunication | null;
  // Sender tracking
  sentById?: string | null;
  sentBy?: {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    username?: string;
  } | null;
};
